<template>
	<div>         
        <p>Please select product</p>
        <b-form-select :disable="disable_product_selection || disable_all" v-model="selected_product" :options="products" class="mb-3">
            <template slot="first">
                <!-- this slot appears above the options from 'options' prop -->
                <option disabled>-- Please select a product --</option>
            </template>
        </b-form-select>
        <i v-show="show_refresh_products" class="margin-left-single-rem fas fa-redo" @click="clickedRefreshProducts"></i>
        <div v-if="group_list.length > 0" class="form-group  text-left">
            <label>Please select group</label>
            <br/>
            <div style="display: flex; flex-direction: row; align-items: center;">
                <b-form-select :disable="disable_group_selection || disable_all" v-model="selected_group" :options="group_list" style="flex-grow: 1;" class="dropdown-class-product">
                <template slot="first">
                    <!-- this slot appears above the options from 'options' prop -->
                    <option disabled>-- Please select a group --</option>
                </template>
                </b-form-select>
                <i v-show="show_refresh_groups" style="margin-right: 1rem;" class="fas fa-redo" @click="clickedRefreshGroups"></i>
            </div>
        </div>

        <div v-show="loading_data" style="font-size: 10pt; font-style: italic; margin-bottom: 1rem;">
            <i style="margin-right: 1rem;" class="fa fa-spinner fa-spin"></i>Loading data...
        </div>
	</div>
</template>

<script>

import utils from "../utils.js";

import PRODUCT_API from '../api/product';
import DEVICE_GROUP_API from '../api/device_group';

import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        disable_all: {
            type: Boolean,
            // Object or array defaults must be returned from
            // a factory function
            default: function () {
                return false;
            }
        },

        remove_group_selected: {
            type: Boolean,
            // Object or array defaults must be returned from
            // a factory function
            default: function () {
                return false;
            }
        },
    },

    data () {
        return {
            selected_product: null,
            selected_group: null,

            group_list: [],

            loading_data: false,

            disable_product_selection: false,
            disable_group_selection: false,

            show_refresh_products: false,
            show_refresh_groups: false
        }
    },

    computed: mapGetters({
        products: 'products',
    }),

    mounted() {
        console.log("ProductDeviceGroupComponent mounted ")

        if (this.products.length == 0) {
            this.clickedRefreshProducts();
        }
    },

    components: {
    },

    watch: {
        selected_product: function(val, oldVal) {
            console.log("selected_product ")
            if (val != "") {
                this.selected_group = null;

                this.clickedRefreshGroups(val)

                this.$emit("changed-product", val);
            }
        },

        selected_group: function(val, oldVal) {
            console.log("selected changed so set the PRODUCT type here!!: "+this.selected)
            this.$emit("changed-group", val);
        },

        remove_group_selected: function(val, oldVal) {
            this.group_list = this.group_list.filter(item => item != this.selected_group);
            this.selected_group = null;
        },
    },

    methods: {
        clickedRefreshProducts: function() {
            const reference = this;

            this.loading_data = true;

            PRODUCT_API.get(
                data => {
                    console.debug(data);

                    if (data != null) {
                        reference.$store.dispatch("setProducts", data);
                    } else {
                        utils.makeToast(reference.$bvToast, "Error", "danger", "The products couldn't be loaded, try again");
                    }
                    reference.loading_data = false;
                },
                e => {
                    console.debug(e);

                    reference.loading_data = false;

                    utils.makeToast(reference.$bvToast, "Error", "danger", "The products couldn't be loaded, try again");
                }
            );
        },

        clickedRefreshGroups: function(product) {
            const reference = this;

            const params = {
                params: {
                    product: product
                }
            }

            this.group_list = [];

            this.loading_data = true;
            this.disable_product_selection = true;

            DEVICE_GROUP_API.fetchGroupsForProduct(params,
                data => {
                    console.debug(data);

                    if (data != null) {
                        reference.group_list = data;
                    } else {
                        utils.makeToast(reference.$bvToast, "Error", "danger", "The groups couldn't be loaded, try again");
                    }
                    reference.loading_data = false;
                    reference.disable_product_selection = false;
                },
                e => {
                    console.debug(e);

                    reference.loading_data = false;
                    reference.disable_product_selection = false;

                    utils.makeToast(reference.$bvToast, "Error", "danger", "The groups couldn't be loaded, try again");
                }
            );
        }
    },
}
</script>

<style lang="stylus" scoped>
.margin-left-single-rem {
    margin-left : 1rem;
}
</style>